import Nullstack from 'nullstack';
export default function IconBrandZhihu({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-zhihu",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M14 6h6v12h-2l-2 2l-1 -2h-1z"
  }), "   ", Nullstack.element("path", {
    d: "M4 12h6.5"
  }), "   ", Nullstack.element("path", {
    d: "M10.5 6h-5"
  }), "   ", Nullstack.element("path", {
    d: "M6 4c-.5 2.5 -1.5 3.5 -2.5 4.5"
  }), "   ", Nullstack.element("path", {
    d: "M8 6v7c0 4.5 -2 5.5 -4 7"
  }), "   ", Nullstack.element("path", {
    d: "M11 18l-3 -5"
  }), " ");
}